import { render, staticRenderFns } from "./AuditVideo.vue?vue&type=template&id=832e7d0a&scoped=true"
import script from "./AuditVideo.vue?vue&type=script&lang=ts"
export * from "./AuditVideo.vue?vue&type=script&lang=ts"
import style0 from "./AuditVideo.vue?vue&type=style&index=0&id=832e7d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832e7d0a",
  null
  
)

export default component.exports